/// <reference types="@angular/localize" />

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from "./environments/environment";

import '@angular/common/locales/global/cs';
import '@angular/common/locales/global/da';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/fi';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/he';
import '@angular/common/locales/global/hu';
import '@angular/common/locales/global/it';
import '@angular/common/locales/global/ja';
import '@angular/common/locales/global/nl';
import '@angular/common/locales/global/no';
import '@angular/common/locales/global/pl';
import '@angular/common/locales/global/pt';
import '@angular/common/locales/global/sk';
import '@angular/common/locales/global/sv';
import '@angular/common/locales/global/tr';

import * as Sentry from "@sentry/angular-ivy";


if(environment.webComponent) {
    const notMigratedServices = environment.notMigratedServices
    for(let service of notMigratedServices){
        if(window.location.href.includes(service)){
            console.log(`Service ${service} not migrated. Updating environment`);
            environment.publicUrl = environment.previousPublicUrl
            environment.frontEndUrl = environment.previousFrontEndUrl
            environment.msal.redirectUri = environment.alternativeRedirectUri
            break;
        }
    }
}


if(environment.environmentName !== 'local'){
    Sentry.init({
        environment: environment.environmentName,
        dsn: environment.sentryDsn,
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: environment.sentryPerformanceTrackingRate, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", environment.sentryTracePropagationApi],
    });

    // Forward console warnings and errors to Sentry so they are tracked as warnings/errors
    const _origWarn = console.warn.bind(console);
    console.warn = (...args: any[]) => {
        try {
            const msg = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
            Sentry.captureMessage(msg, 'warning');
        } catch (e) {
            // ignore
        }
        _origWarn(...args);
    };

    const _origError = console.error.bind(console);
    console.error = (...args: any[]) => {
        try {
            const first = args[0];
            if (first instanceof Error) {
                Sentry.captureException(first);
            } else {
                const msg = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
                Sentry.captureMessage(msg, 'error');
            }
        } catch (e) {
            // ignore
        }
        _origError(...args);
    };
}

if (environment.production) {
    enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
